module.exports = __webpack_public_path__ + "static/media/19-8.c730db93.mp3";